export default __webpack_public_path__ + "841746e48d5f6715939f457355a6d111.png";